
<div class="content-container bg-white">

  <h1>{{ 'communicationChannel.contact.title' | translate }}</h1>

  <div class="btn-bar justify-content-start" [appHasAnyPermission]="[PermissionKeys.gestionCommunication]">
    <button class="btn btn-link" [routerLink]="['manage']">
      <fa-icon class="me-2" [icon]="icons.pen"></fa-icon>
      <span translate="common.manageInfo"></span>
    </button>
  </div>

  @if (!!config) {
    <div class="row">
      <div class="col-12">
        <label class="form-label" for="message">{{ 'contact.message' | translate }}*</label>
        <textarea id="message" class="form-control"
          name="message"
          rows="4"
          placeholder="{{ 'contact.placeholder' | translate }}"
        [formControl]="message"></textarea>
      </div>
    </div>
  }

  <div class="btn-bar">
    <button type="submit" class="btn btn-primary"
      [disabled]="message.invalid"
      (click)="sendMessage()"
      translate="common.send">
    </button>
  </div>

  @if (config) {
    <h5>{{ 'common.cgu' | translate }}</h5>
  } @else {
    <h5>{{ 'communicationChannel.contact.notification.noConfiguration' | translate }}</h5>
  }

  <div>
    {{ (!!this.config) ? this.config['cgu' + crtLang.toUpperCase()] : '' }}
  </div>

</div>
